"use client";

/**
 * P14-09 · The search box on the not-found page.
 *
 * A client component for one reason: the form's `action` has to be
 * locale-aware, and `useLocaleHref` is the seam that knows how (a brand that
 * hides its default-locale prefix must not get `/en/search`). A plain
 * `action="/search"` would send every French shopper to the English results.
 *
 * Deliberately a real `<form method="get">` rather than the header's overlay:
 * this is a dead end, so the first thing on the page should be a way out that
 * works before hydration and without JavaScript at all.
 */
import { useLocaleHref, useTranslator } from "~/i18n/provider";

export function NotFoundSearch() {
  const t = useTranslator();
  const build = useLocaleHref();

  return (
    <form
      method="get"
      action={build("/search")}
      role="search"
      className="flex w-full max-w-md flex-col gap-2 sm:flex-row"
    >
      <label htmlFor="not-found-q" className="sr-only">
        {t("notFound.searchLabel")}
      </label>
      <input
        id="not-found-q"
        type="search"
        name="q"
        autoComplete="off"
        placeholder={t("notFound.searchPlaceholder")}
        className="min-w-0 flex-1 rounded-md border border-border bg-surface px-3 py-2 text-fg outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      />
      <button
        type="submit"
        className="rounded-[var(--btn-radius)] bg-primary px-4 py-2 text-sm text-primary-fg [font-weight:var(--btn-weight)] hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
      >
        {t("notFound.searchAction")}
      </button>
    </form>
  );
}
